<template>
  <nav class="sticky top-4 flex flex-col gap-4" aria-label="Innholdsfortegnelse">
    <div v-for="(item, index) in sections" :key="$uuid(index)" class="px-5 py-4 text-lg">
      <button @click="setSection(item.contentGuid)" class="text-left flex gap-2 group"
        :class="item.contentGuid === openSection ? 'font-semibold' : 'font-normal'" title="{{ item.title }}">
        <span>&bull;</span>
        <span class="group-hover:underline group-hover:text-red-300">{{ item.title }}</span>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    sections: {
      type: Object,
      required: true,
    },
    openSection: {
      type: String,
      required: false,
    },
    level: {
      type: Number,
      required: false,
    },
  },
  methods: {
    setSection(id) {
      this.$emit('toggleSections', id);
    },
  },
};
</script>
